var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share-box"},[_c('p',[_vm._v("share")]),_vm._v(" "),_c('a',{staticClass:"line",attrs:{"href":'https://social-plugins.line.me/lineit/share?url=' + _vm.href}},[_c('i')]),_vm._v(" "),_c('a',{staticClass:"fb",attrs:{"target":"_blank","href":'https://www.facebook.com/sharer/sharer.php?u='+_vm.href}},[_c('i')])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-196ae3fc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/shared/Socialmedia.vue
// module id = null
// module chunks = 